import { ErrorInfo } from '../models/ErrorInfo';
import ApiResponse from '../models/api/ApiResponse';
import ParamsApi from '../models/api/ParamsApi';
import RestApiClient from './restApiClient';
import { downloadFile, DownloadFileResult } from './downloadFile';

//Mocks
import { templateInfo } from '../mocks/templates';
import { AccountFilter, AccountUsersAdministrationFilter } from '../models/AccountsFilter';
import { BookingExportPreset, BookingFilter } from '../models/BookingsFilter';
import { UsersFilterData, UsersFilterData2 } from '../models/UsersFilterData';
import { CreateFieldRegisterFormDto, EditFieldRegisterFormDto } from '../models/RegisterFormData';
import { CreateBudgetDto, EditBudgetDto, EditGroupFormDto, EditLandingPageOptionDto, EditPROPersonalitationDto, LandingPageCodeData } from '../models/ConfigurationData';
import { userDataList } from '../mocks/users';
import NewUserData from '../models/NewUserData';
import EditUserData from '../models/EditUserData';
import { clientLanguagesMock } from '../mocks/configuration';
import { RegisterFormFilterData } from '../models/RegisterFormData';
import RoomConfigData, { HotelsConfigCreateData, HotelsConfigEditData, HotelsConfigEditStatusData, RegimesConfigCreateData, RegimesConfigData, RoomConfigCreateData, RoomConfigDataEdit, ServicesConfigCreateData, ServicesConfigData } from '../models/MappingData';
import { UserProfile } from '../models/UsersInfo';
import { EditAccountStatusData } from '../models/UserData';
import { AccountChangeStatusDto } from '../models/AccountUserData';
import CreateContract from '../models/CreateContract';
import { NewsData } from '../models/CommunicationsData';
import { AccountValues, ConfigurationsFilter, EditAccountAsignationData } from '../models/AccountAsignationData';
import { EditPaymentConfigurationData, PaymentConfigurationData, PaymentConfigurationsFilter } from '../models/PaymentMethodData';
import { ImportBookingRewardsData } from '../models/ImportBookingRewardsData';
import { CompleteBookingPaymentRequest } from '../models/BookingInfo';

const sleep = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));

var restApiClient: RestApiClient = new RestApiClient();;

// Si esta variable está a TRUE cuando se produce un error en una llamada API se redirige al usuario a la página de error
const REDIRECT_TO_ERROR_PAGE: boolean = true;


export async function pushErrorNotificationData(errorInfo: ErrorInfo): Promise<ApiResponse | null> {
    console.warn("Calling to: pushErrorNotificationData", errorInfo);

    try {
        return {
            additionalMessages: [],
            code: 200,
            data: true,
            message: "",
            type: 200,
            typeToString: "Success"
        };

        const response = await restApiClient.fetch("PushErrorNotification", {
            body: errorInfo
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}

export async function fetchClientAppCustomData(): Promise<ApiResponse | null> {
    try {

        console.warn("Calling to: fetchClientAppCustomData");

        const response = await restApiClient.fetch("GetCustomAppDataBO", {}, REDIRECT_TO_ERROR_PAGE);

        return response!;

    } catch (error) {
        console.error('Error fetching colors:', error);
        return null;
    }
}
export async function fetchAditionalConfig(): Promise<ApiResponse | null> {
    try {

        console.warn("Calling to: fetchAditionalConfig");

        const response = await restApiClient.fetch("RegisterForm/GetAditionalConfiguration", {}, false);

        return response!;

    } catch (error) {
        console.error('Error fetching additional config info:', error);
        return null;
    }
}


export async function fetchClientPROPersonalitationData(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchClientPROPersonalitationData");

        const response = await restApiClient.fetch("GetPROPersonalitationData", {}, false);
        return response!;

    } catch (error) {
        console.error('Error fetching client PRO Personalitation Data:', error);
        return null;
    }
}


export async function editPROConfiguration(dto: EditPROPersonalitationDto): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: editPROConfiguration");

        var params: ParamsApi = {
            body: dto  // Enviar el objeto DTO directamente
        };

        const response = await restApiClient.fetch("EditPROPersonalitationData", params);
        return response!;

    } catch (error) {
        console.error('Error editing PRO Configuration:', error);
        return null;
    }
}

export async function editLandingPageOptions(dto: EditLandingPageOptionDto): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: editLandingPageOptions");

        var params: ParamsApi = {
            body: dto  // Enviar el objeto DTO directamente
        };

        const response = await restApiClient.fetch("EditLandingPageOption", params);
        return response!;

    } catch (error) {
        console.error('Error editing Landing Page Options:', error);
        return null;
    }
}







export async function createFieldRegisterForm(createFieldRegisterFormDto: CreateFieldRegisterFormDto): Promise<ApiResponse | null> {
    console.warn("Calling to: createFieldRegisterForm", createFieldRegisterFormDto);

    try {


        const response = await restApiClient.fetch("CreateFieldRegisterForm", {
            body: createFieldRegisterFormDto
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error post field register form :', error);
        return null;
    }
}


export async function editFieldRegisterForm(editFieldRegisterFormDto: EditFieldRegisterFormDto): Promise<ApiResponse | null> {
    console.warn("Calling to: editFieldRegisterForm", editFieldRegisterFormDto);

    try {
        const response = await restApiClient.fetch("EditFieldRegisterForm", {
            body: editFieldRegisterFormDto
        }, REDIRECT_TO_ERROR_PAGE);

        return response!;

    } catch (error) {
        console.error('Error edit field register form :', error);
        return null;
    }
}



export async function getLoginWidgetScript(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: getLoginWidgetScript");
        var params: ParamsApi = {
            query: {

            }
        };

        const response = await restApiClient.fetch("GetLoginScript", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching login widget script:', error);
        return null;
    }
}




export async function fetchFilterFieldsRegisterForm(filterData: RegisterFormFilterData): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchFieldsRegisterForm");
        var params: ParamsApi = {
            query: {
                status: filterData.status,
                fieldType: filterData.fieldType,
                label: filterData.label,
                language: filterData.language,
                nameField: filterData.nameField,
                page: filterData.page,
                pageSize: filterData.pageSize
            }
        };


        const response = await restApiClient.fetch("FilterFieldsRegisterForm", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching filter fields register form:', error);
        return null;
    }
}




export async function editStatusFieldForm(id: string, isActive: boolean): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: editStateFieldForm");

        var params: ParamsApi = {
            body: {
                id: id,
                isActive: isActive
            }
        }

        const response = await restApiClient.fetch("ChangeFieldFormStatus", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error editing field form status:', error);
        return null;
    }
}



export async function deleteFieldRegisterForm(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteFieldRegisterForm");

        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("DeleteField", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error deleting field form:', error);
        return null;
    }
}




export async function editLandingPageCode(editLandingPageDto: LandingPageCodeData): Promise<ApiResponse | null> {
    console.warn("Calling to: editLandingPageCode", editLandingPageDto);

    try {


        const response = await restApiClient.fetch("EditLandingPageCode", {
            body: editLandingPageDto
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error editing langing page code:', error);
        return null;
    }
}



export async function fetchLandingPageCode(language: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchLandingPageCode");


        var params: ParamsApi = {
            query: {
                languageId: language
            }
        }

        const response = await restApiClient.fetch("GetLandingPageCode", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching landing page code:', error);
        return null;
    }
}


export async function fetchGroupForm(language: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchGroupForm");


        var params: ParamsApi = {
            query: {
                languageId: language
            }
        }

        const response = await restApiClient.fetch("GetFormGroupData", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching group form data :', error);
        return null;
    }
}




export async function editGroupForm(data: EditGroupFormDto): Promise<ApiResponse | null> {
    console.warn("Calling to: editGroupForm", data);
    try {
        const response = await restApiClient.fetch("EditGroupForm", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing group form :', error);
        return null;
    }
}



export async function fetchServicesChosen(language: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchServicesChosen");

        var params: ParamsApi = {
            query: {
                languageId: language
            }
        }


        const response = await restApiClient.fetch("GetServicesChosenFormGroup", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching services chosen:', error);
        return null;
    }
}


export async function fetchOptionsServices(language: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchOptionsServices");



        var params: ParamsApi = {
            query: {
                languageId: language
            }
        }

        const response = await restApiClient.fetch("GetServicesFormGroup", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching options services:', error);
        return null;
    }
}



// si el return shortcode es true, se devuelve solo el shortCode, sino, se devuelve el id
export async function fetchLanguagesAvailables(origin: string, returnShortCode: boolean = true): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchLanguagesAvailables");

        const params: ParamsApi = {
            query: {
                origin: origin,
                returnShortCode: returnShortCode

            }
        }

        const response = await restApiClient.fetch("GetAvailableLanguages", params);
        return response!;

    } catch (error) {
        console.error('Error fetching languages:', error);
        return null;
    }
}


// ------------ REGIMEN--------------------



export async function editRegimesConfig(data: RegimesConfigData): Promise<ApiResponse | null> {
    console.warn("Calling to: editRoomConfig", data);

    try {
        const response = await restApiClient.fetch("EditRegimeConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing regimes config :', error);
        return null;
    }
}

export async function createRegimesConfig(data: RegimesConfigCreateData): Promise<ApiResponse | null> {
    console.warn("Calling to: createRegimesConfig", data);

    try {

        const response = await restApiClient.fetch("CreateRegimeConfigMapping", {
            body: data
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error creating regimes config :', error);
        return null;
    }
}


export async function deleteRegimesConfigMapping(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteRegimesConfigMapping");



        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("DeleteRegimenConfigMapping", params,);
        return response!;

    } catch (error) {
        console.error('Error editing field form:', error);
        return null;
    }
}



export async function fetchRegimesConfigMapping(name: string, language: string, page: number, pageSize: number): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchRegimesConfigMapping");

        var params: ParamsApi = {
            query: {
                filter: name,
                language: language,
                page: page,
                pageSize: pageSize
            }
        }

        const response = await restApiClient.fetch("GetRegimenConfigMapping", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching regimes config mapping:', error);
        return null;
    }
}

// ----------------ROOM----------------------

export async function fetchRoomConfigMapping(name: string, language: string, page: number, pageSize: number): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchRoomConfigMapping");


        var params: ParamsApi = {
            query: {
                filter: name,
                language: language,
                page: page,
                pageSize: pageSize
            }
        }


        const response = await restApiClient.fetch("GetRoomConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error fetching room config mapping:', error);
        return null;
    }
}






export async function editRoomConfig(data: RoomConfigDataEdit): Promise<ApiResponse | null> {
    console.warn("Calling to: editRoomConfig", data);

    try {


        const response = await restApiClient.fetch("EditRoomConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing room config :', error);
        return null;
    }
}

export async function createRoomConfig(data: RoomConfigCreateData): Promise<ApiResponse | null> {
    console.warn("Calling to: createRoomConfig", data);

    try {

        const response = await restApiClient.fetch("CreateRoomConfigMapping", {
            body: data
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error creating room config :', error);
        return null;
    }
}


export async function deleteRoomConfigMapping(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteRoomConfigMapping");

        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("DeleteRoomConfigMapping", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error deleting field form:', error);
        return null;
    }
}





// ------ HOTELS--------



export async function editHotelsConfig(data: HotelsConfigEditData): Promise<ApiResponse | null> {
    console.warn("Calling to: editHotelsConfig", data);

    try {
        const response = await restApiClient.fetch("EditHotelConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing hotels config :', error);
        return null;
    }
}

export async function createHotelsConfig(data: HotelsConfigCreateData): Promise<ApiResponse | null> {
    console.warn("Calling to: createHotelsConfig", data);

    try {

        const response = await restApiClient.fetch("CreateHotelConfigMapping", {
            body: data
        }, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error creating regimes config :', error);
        return null;
    }
}


export async function deleteHotelsConfigMapping(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteHotelsConfigMapping");



        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("DeleteHotelConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error deleting hotel config form:', error);
        return null;
    }
}



export async function fetchHotelsConfigMapping(language: string, name: string, page: number, pageSize: number): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchHotelsConfigMapping");

        var params: ParamsApi = {
            query: {
                page: page,
                pageSize: pageSize,
                filter: name,
                language: language
            }
        }

        const response = await restApiClient.fetch("GetHotelConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error fetching hotels config mapping:', error);
        return null;
    }
}


export async function editHotelsStatusConfig(data: HotelsConfigEditStatusData): Promise<ApiResponse | null> {
    console.warn("Calling to: editHotelsStatusConfig", data);

    try {


        const response = await restApiClient.fetch("UpdateStateHotelConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing hotels state config :', error);
        return null;
    }
}



// si le paso que idHotel es nulo, es porque es nuevo
export async function fetchHotelsRooms(language: string, idHotel: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchHotelsRooms");


        var params: ParamsApi = {
            query: {
                idHotel: idHotel,
                language: language,
            }
        }

        const response = await restApiClient.fetch("GetHotelRoomsConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error fetching hotels rooms config mapping:', error);
        return null;
    }
}



// si le paso que idHotel es nulo, es porque es nuevo
export async function fetchHotelsRegimens(language: string, idHotel: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchHotelsRegimens");

        var params: ParamsApi = {
            query: {
                idHotel: idHotel,
                language: language,
            }
        }

        const response = await restApiClient.fetch("GetHotelRegimesConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error fetching hotels regimes config mapping:', error);
        return null;
    }
}


// -----------------------------------------



// -.----------------------SERVICE-----------------
// si name tiene un valor, entonces es para filtar
export async function fetchServicesConfigMapping(name: string, language: string, page: number, pageSize: number): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchServicesConfigMapping");

        var params: ParamsApi = {
            query: {
                filter: name,
                language: language,
                page: page,
                pageSize: pageSize
            }
        }

        const response = await restApiClient.fetch("GetServiceConfigMapping", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching services config mapping:', error);
        return null;
    }
}

export async function getAllServices(language? :string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: getAllServices", language);

        var params: ParamsApi = {
            query: {
                ...(language && { language: language })
            }
        }

        const response = await restApiClient.fetch("GetAllServices", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching services config mapping:', error);
        return null;
    }
}



export async function deleteServiceConfigMapping(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteServiceConfigMapping");

        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("DeleteServiceConfigMapping", params);
        return response!;

    } catch (error) {
        console.error('Error deleting service config :', error);
        return null;
    }
}



export async function deletePendingBookings(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deletePendingBookings");

        var params: ParamsApi = {
            query: {
                
            }
        }

        const response = await restApiClient.fetch("DeletePendingBookings", params);
        return response!;

    } catch (error) {
        console.error('Error deleting pending bookings :', error);
        return null;
    }
}



export async function createServicesConfig(data: ServicesConfigCreateData): Promise<ApiResponse | null> {
    console.warn("Calling to: createServicesConfig", data);

    try {

        const response = await restApiClient.fetch("CreateServiceConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error creating services config :', error);
        return null;
    }
}



export async function editServicesConfig(data: ServicesConfigData): Promise<ApiResponse | null> {
    console.warn("Calling to: editServicesConfig", data);

    try {

        const response = await restApiClient.fetch("EditServiceConfigMapping", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error editing services config :', error);
        return null;
    }
}



export async function editBudgetGroupForm(data: EditBudgetDto): Promise<ApiResponse | null> {
    console.warn("Calling to: editBudgetGroupForm", data);

    try {

        const response = await restApiClient.fetch("EditBudgetGroupForm", {
            body: data
        });
        return response!;



    } catch (error) {
        console.error('Error editing budget :', error);
        return null;
    }
}

export async function createBudgetGroupForm(data: CreateBudgetDto): Promise<ApiResponse | null> {
    console.warn("Calling to: createBudgetGroupForm", data);

    try {
        const response = await restApiClient.fetch("CreateBudgetGroupForm", {
            body: data
        });
        return response!;

    } catch (error) {
        console.error('Error creating budget :', error);
        return null;
    }
}


export async function deleteBudgetGroupForm(budgetId: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteBudgetGroupForm");



        var params: ParamsApi = {
            query: {
                budgetId: budgetId
            }
        }

        const response = await restApiClient.fetch("DeleteBudgetGroupForm", params);
        return response!;

    } catch (error) {
        console.error('Error deleting budget:', error);
        return null;
    }
}






// si le paso que idHotel es nulo, es porque es nuevo
export async function fetchBudgetsGroupForm(languageId: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchBudgetsGroupForm");


        var params: ParamsApi = {
            query: {
                languageId: languageId
            }
        }


        const response = await restApiClient.fetch("GetBudgetsGroupForm", params);
        return response!;

    } catch (error) {
        console.error('Error fetching bugdets group form:', error);
        return null;
    }
}



// si le paso que idHotel es nulo, es porque es nuevo
export async function fetchBudgetsGroupFormById(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchBudgetsGroupForm");


        var params: ParamsApi = {
            query: {
                id: id
            }
        }


        const response = await restApiClient.fetch("GetBudgetsGroupFormById", params);
        return response!;

    } catch (error) {
        console.error('Error fetching bugdets group form:', error);
        return null;
    }
}



export async function useDoLogin(username: string, password: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: useDoLogin", username, password);

        var params: ParamsApi = {
            body: {
                userData: username,
                password: password
            }
        }

        const response = await restApiClient.fetch("LoginFromBackOffice", params);
        return response!;

    } catch (error) {
        console.error('Error doing the login :', error);
        return null;
    }
}

export async function useCloseSession(idUser: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: useCloseSession", idUser);

        var params: ParamsApi = {
            query: {
                userId: idUser
            }
        }

        const response = await restApiClient.fetch("Logout", params);
        return response!;

    } catch (error) {
        console.error('Error doing log out :', error);
        return null;
    }
}

export async function useRecoverPassword(email: string): Promise<ApiResponse | null> {
    try {

        const data = {
            email: email,
            app: "bo"
        }
        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("RecoverPassword", params);
        return response!;

    } catch (error) {
        console.error('Error recovering password :', error);
        return null;
    }
}
export async function changePassword(email: string, password: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: changePassword")

        var params: ParamsApi = {
            body: {
                app: "bo",
                email: email,
                password: password
            }
        }

        const response = await restApiClient.fetch("ChangePassword", params);
        return response!;

    } catch (error) {
        console.error('Error doing log in :', error);
        return null;
    }
}


export async function getEmailByRecoveryHash(token: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: getEmailByRecoveryHash")

        var params: ParamsApi = {
            query: {
                app: "bo",
                token: token
            }
        }

        const response = await restApiClient.fetch("GetEmailByRecoveryHash", params);
        return response!;

    } catch (error) {
        console.error('Error doing log in :', error);
        return null;
    }
}



export async function fetchTemplateInfo(): Promise<ApiResponse | null> {
    console.warn("Calling to: getTemplateInfo");
    try {
        return {
            additionalMessages: [],
            code: 200,
            data: templateInfo,
            message: "",
            type: 200,
            typeToString: "Success"
        };

        const response = await restApiClient.fetch("getClientTemplate", {}, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function isValidUsername(username: string): Promise<ApiResponse | null> {
    console.warn("Calling to: checkUsername");
    try {
        var params: ParamsApi = {
            query: {
                username: username
            }
        }

        const response = await restApiClient.fetch("CheckIsValidNewUsername", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function fetchAccounts(filterData: AccountFilter): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchAccounts", filterData);

    try {
        var params: ParamsApi = {
            query: {
                name: filterData.name,
                email: filterData.email,
                status: filterData.status,
                location: filterData.location,
                accountType: filterData.accountType,
                page: filterData.page,
                pageSize: filterData.pageSize
            }
        }


        const response = await restApiClient.fetch("GetAccounts", params);
        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}



export async function fetchUserAccounts(filterData: AccountUsersAdministrationFilter): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchUserAccounts", filterData);
    try {
        var params: ParamsApi = {
            query: {
                name: filterData.name,
                email: filterData.email,
                status: filterData.status,
                location: filterData.location,
                accountType: filterData.accountType,
                id: filterData.id
            }
        }
        const response = await restApiClient.fetch("GetUserAccounts", params);
        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}



export async function fetchBookings(filterData: BookingFilter): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchBookings", filterData);

    try {

        var params: ParamsApi = {
            query: {
                page: filterData?.page ?? 0,
                pageSize: filterData?.pageSize ?? 10
            }
        };

        // Solo agrega los campos de texto si tienen valor real
        if (filterData?.locator)    params.query.locator    = filterData.locator;
        if (filterData?.status)     params.query.status     = filterData.status;
        if (filterData?.agency)     params.query.agency     = filterData.agency;
        if (filterData?.location)   params.query.location   = filterData.location;
        if (filterData?.name)       params.query.name       = filterData.name;
        if (filterData?.ownLocator) params.query.ownLocator = filterData.ownLocator;
        if (filterData?.userEmail)  params.query.userEmail  = filterData.userEmail;

        // Solo agrega checkIn y checkOut si no son null
        if (filterData?.checkIn) {
            params.query.checkIn = filterData.checkIn;
        }
        if (filterData?.checkOut) {
            params.query.checkOut = filterData.checkOut;
        }

        // hotelList: array de hoteles seleccionados o array vacío si no hay selección
        params.query.hotelList = (filterData?.hotel && filterData.hotel.length > 0)
            ? JSON.stringify(filterData.hotel)
            : JSON.stringify([]);


        const response = await restApiClient.fetch("getBookings", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}



/**
 * Exporta las reservas a XLSX. No pasa por RestApiClient porque la respuesta puede ser binaria.
 * El 'preset' es el atajo del desplegable y se aplica SOBRE el filtro del formulario.
 */
export async function exportBookings(filterData: BookingFilter, preset?: BookingExportPreset | null): Promise<DownloadFileResult | null> {
    console.warn("Calling to: exportBookings", filterData, preset);

    try {

        var query: any = {};

        // Solo agrega los campos de texto si tienen valor real
        if (filterData?.locator)    query.locator    = filterData.locator;
        if (filterData?.status)     query.status     = filterData.status;
        if (filterData?.agency)     query.agency     = filterData.agency;
        if (filterData?.location)   query.location   = filterData.location;
        if (filterData?.name)       query.name       = filterData.name;
        if (filterData?.ownLocator) query.ownLocator = filterData.ownLocator;
        if (filterData?.userEmail)  query.userEmail  = filterData.userEmail;

        // Solo agrega checkIn y checkOut si no son null
        if (filterData?.checkIn) {
            query.checkIn = filterData.checkIn;
        }
        if (filterData?.checkOut) {
            query.checkOut = filterData.checkOut;
        }

        // hotelList: array de hoteles seleccionados o array vacío si no hay selección
        query.hotelList = (filterData?.hotel && filterData.hotel.length > 0)
            ? JSON.stringify(filterData.hotel)
            : JSON.stringify([]);

        // El atajo del desplegable manda sobre lo que haya en el formulario
        if (preset?.status)      query.status      = preset.status;
        if (preset?.createdFrom) query.createdFrom = preset.createdFrom;
        if (preset?.createdTo)   query.createdTo   = preset.createdTo;

        const response = await downloadFile("Bookings", "ExportBookings", query);

        return response;

    } catch (error) {
        console.error('Error exporting bookings:', error);
        return null;
    }
}



export async function exportAccountsCommissions(filterData: AccountFilter, dateFrom: string, dateTo: string): Promise<DownloadFileResult | null> {
    console.warn("Calling to: exportAccountsCommissions", filterData, dateFrom, dateTo);

    try {

        const response = await downloadFile("Accounts", "ExportAccountsCommissions", {
            name: filterData.name,
            email: filterData.email,
            status: filterData.status,
            location: filterData.location,
            accountType: filterData.accountType,
            dateFrom: dateFrom,
            dateTo: dateTo,
        });

        return response;

    } catch (error) {
        console.error('Error exporting accounts commissions:', error);
        return null;
    }
}



export async function exportAccountUsersCommissions(filterData: AccountUsersAdministrationFilter, dateFrom: string, dateTo: string): Promise<DownloadFileResult | null> {
    console.warn("Calling to: exportAccountUsersCommissions", filterData, dateFrom, dateTo);

    try {

        const response = await downloadFile("Accounts", "ExportAccountUsersCommissions", {
            accountId: filterData.id,
            accountType: filterData.accountType,
            name: filterData.name,
            email: filterData.email,
            status: filterData.status,
            dateFrom: dateFrom,
            dateTo: dateTo,
        });

        return response;

    } catch (error) {
        console.error('Error exporting account users commissions:', error);
        return null;
    }
}




export async function fetchBookingsByUserId(id: string, typeAccount: string): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchBookings", id);

    try {

        var params: ParamsApi = {
            query: {
                id: id,
                type: typeAccount
            }
        };

        const response = await restApiClient.fetch("GetBookingsByAccountId", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function fetchHotels(): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchHotels");

    try {
        const response = await restApiClient.fetch("GetHotels", {});

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}

export async function fetchBookingData(bookingId: string, language: string): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchBookingData");
    try {
        var params: ParamsApi = {
            query: {
                id: bookingId,
                language : language
            }
        }

        const response = await restApiClient.fetch("GetBookingData", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function changeAccountUserStatus(userId: string, status: string, oldStatus: string): Promise<ApiResponse | null> {
    console.warn("Calling to: changeAccountUserStatus");
    try {
        var data: EditAccountStatusData = {
            idUser: userId,
            status: status,
            oldStatus: oldStatus
        }

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("EditAccountStatus", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


// el id puede ser el id del usuario (agente independiente o organizador de ventos) o el id de la compañia/agencia
export async function editAccount(id: string, isActive: boolean, typeAccount: string, contractConfigurationId: string[], paymentConfigurationId: string, useSpecificConfiguration: boolean | null, verificationCode?: string): Promise<ApiResponse | null> {
    console.warn("Calling to: EditAccount");

    try {
        var data: AccountChangeStatusDto = {
            id: id,
            status: isActive ? "active" : "inactive",
            typeAccount: typeAccount,
            commissionConfigurationSelected: contractConfigurationId,
            paymentConfigurationSelected: paymentConfigurationId,
            ...(useSpecificConfiguration != null && { useSpecificConfiguration }),
            ...(verificationCode !== undefined && verificationCode !== '' && { verificationCode })
        }

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("EditAccount", params);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}

export async function deleteAccount(accountId: string, accountType: string): Promise<ApiResponse | null> {
    console.warn("Calling to: DeleteAccount");

    try {
        var params: ParamsApi = {
            query: {
                accountId,
                accountType
            }
        }

        const response = await restApiClient.fetch("DeleteAccount", params);

        return response;

    } catch (error) {
        console.error('Error deleting account:', error);
        return null;
    }
}

export async function updateVerificationCode(id: string, typeAccount: string, currentStatus: string, verificationCode: string): Promise<ApiResponse | null> {
    console.warn("Calling to: updateVerificationCode");

    try {
        var data = {
            id,
            typeAccount,
            status: currentStatus,
            commissionConfigurationSelected: [],
            paymentConfigurationSelected: '',
            verificationCode
        };

        var params: ParamsApi = { body: data };

        const response = await restApiClient.fetch("EditAccount", params);

        return response;

    } catch (error) {
        console.error('Error updating verification code:', error);
        return null;
    }
}



export async function createUser(data: NewUserData): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: createUser", data);



        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("create/BackOfficeUser", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching colors:', error);
        return null;
    }
}





export async function editUser(data: EditUserData): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: editUser", data);

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("edit/BackOfficeUser", params);
        return response!;

    } catch (error) {
        console.error('Error fetching colors:', error);
        return null;
    }
}


export async function filterUsers(filterData: UsersFilterData2): Promise<ApiResponse | null> {
    console.warn("Calling to: filterUsers", filterData);

    try {

        var params: ParamsApi = {
            query: {
                name: filterData.name,
                email: filterData.email,
                username: filterData.username,
                state: filterData.state,
                role: filterData.role,
                page: filterData.page,
                pageSize: filterData.pageSize
            }
        }

        const response = await restApiClient.fetch("filter/BackOfficeUser", params, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}




export async function fetchUserDataEdition(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchUserDataEdition");

        var params: ParamsApi = {
            query: {
                id: id
            }
        }

        const response = await restApiClient.fetch("GetUserDataProfile", params);
        return response!;

    } catch (error) {
        console.error('Error fetching User profile data:', error);
        return null;
    }

}


export async function editUserProfileData(data: UserProfile): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: editUserProfileData");

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("EditUserDataProfile", params);
        return response!;

    } catch (error) {
        console.error('Error fetching User profile data:', error);
        return null;
    }

}



export async function fetchContracts(filterData: { f: string, p: number, s: number }): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchContracts", filterData);
    try {
        var params: ParamsApi = {
            query: {
                filter: filterData.f,
                page: filterData.p,
                size: filterData.s
            }
        }

        const response = await restApiClient.fetch("GetContracts", params, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function fetchContractById(id: string): Promise<ApiResponse | null> {
    console.warn("Calling to: fetchContractById", id);
    try {
        var params: ParamsApi = {
            query: {
                contractId: id
            }
        }

        const response = await restApiClient.fetch("GetContract", params, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}

export async function changeContractStatus(contractId: string, isActive: boolean): Promise<ApiResponse | null> {
    console.warn("Calling to: changeContractStatus", contractId, isActive);

    try {
        var params: ParamsApi = {
            query: {
                contractId: contractId,
                newStatus: isActive
            }
        }

        const response = await restApiClient.fetch("ChangeContractStatus", params, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}

export async function deleteContract(contractId: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteContract");

        var params: ParamsApi = {
            query: {
                contractId: contractId
            }
        }

        const response = await restApiClient.fetch("DeleteContract", params, REDIRECT_TO_ERROR_PAGE);

        return response;
    } catch (error) {
        console.error('Error deleting field form:', error);
        return null;
    }
}

export async function createContract(data: CreateContract): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: createContract", data);

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("AddContract", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching colors:', error);
        return null;
    }
}

export async function updateContract(data: CreateContract): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: updateContract", data);

        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("UpdateContract", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error fetching colors:', error);
        return null;
    }
}

export async function fetchNews(title: string, status: string, page: number, pageSize: number): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: fetchNews");

        var params: ParamsApi = {
            query: {
                title: title,
                status: status,
                page: page,
                pageSize: pageSize
            }
        }

        const response = await restApiClient.fetch("GetNews", params);
        return response!;

    } catch (error) {
        console.error('Error fetching news:', error);
        return null;
    }

}


export async function deleteNews(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteNews");
        var params: ParamsApi = {
            query: {
                id: id,
            }
        }
        const response = await restApiClient.fetch("DeleteNews", params);
        return response!;

    } catch (error) {
        console.error('Error deleting news:', error);
        return null;
    }

}


export async function ChangeNewsStatus(id: string, isActive: boolean): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: ChangeNewsStatus");
        var params: ParamsApi = {
            body: {
                id: id,
                isActive: isActive
            }
        }
        const response = await restApiClient.fetch("ChangeNewsStatus", params);
        return response!;

    } catch (error) {
        console.error('Error changing status :', error);
        return null;
    }

}



export async function EditFeaturedNews(id: string, isActive: boolean): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: EditFeaturedNews");
        var params: ParamsApi = {
            body: {
                id: id,
                isFeatured: isActive
            }
        }
        const response = await restApiClient.fetch("EditFeaturedNews", params);
        return response!;

    } catch (error) {
        console.error('Error changing status :', error);
        return null;
    }

}



export async function GetNewsData(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: getNewsData");
        var params: ParamsApi = {
            query: {
                id: id,
            }
        }
        const response = await restApiClient.fetch("GetNewsDataBO", params);
        return response!;

    } catch (error) {
        console.error('Error getting  news data:', error);
        return null;
    }

}


export async function CreateNews(d: NewsData, id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CreateNews");

        const data = {
            idUser: id,
            imgContentType: d.imgContentType,
            imgName: d.imgName,
            base64Image: d.base64Image,
            TitlesByLanguage: d.titlesByLanguage,
            DescriptionsByLanguage: d.descriptionsByLanguage,
            isSheduled: d.sheduleDayFrom != null,
            sheduleDateFrom: d.sheduleDayFrom?.toISOString() ?? null,
            sheduleDateTo: d.sheduleDayTo?.toISOString() ?? null,
            isFeatured: d.isFeatured,
            status: d.status
        }
        var params: ParamsApi = {
            body: data
        }
        const response = await restApiClient.fetch("CreateNews", params);
        return response!;


    } catch (error) {
        console.error('Error creating news data:', error);
        return null;
    }

}




export async function EditNews(d: NewsData): Promise<ApiResponse | null> {
    try {

        const data = {
            id: d.id,
            imgContentType: d.imgContentType,
            imgName: d.imgName,
            base64Image: d.base64Image,
            TitlesByLanguage: d.titlesByLanguage,
            DescriptionsByLanguage: d.descriptionsByLanguage,
            isSheduled: d.sheduleDayFrom != null,
            sheduleDateFrom: d.sheduleDayFrom?.toISOString() ?? null,
            sheduleDateTo: d.sheduleDayTo?.toISOString() ?? null,
            isFeatured: d.isFeatured,
            status: d.status
        }
        var params: ParamsApi = {
            body: data
        }
        const response = await restApiClient.fetch("EditNews", params);
        return response!;

    } catch (error) {
        console.error('Error editting  news data:', error);
        return null;
    }

}


export async function GetCommisionConfiguration(data: ConfigurationsFilter): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: getAssignationAccounts");
        var params: ParamsApi = {
            query: {
                name: data.name ?? "",
                page: data.page ?? 0,
                pageSize: data.pageSize ?? 10
            }
        }
        const response = await restApiClient.fetch("GetCommisionConfiguration", params);
        return response!;

    } catch (error) {
        console.error('Error getting GetCommisionConfiguration data:', error);
        return null;
    }

}

export async function GetConfigurationAvailableForAccount(accountId: string, accountType: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetConfigurationAvailableForAccount");
        var params: ParamsApi = {
            query: {
                accountId: accountId,
                accountType: accountType
            }
        }
        const response = await restApiClient.fetch("GetConfigurationAvailableForAccount", params);
        return response!;

    } catch (error) {
        console.error('Error getting GetConfigurationAvailableForAccount data:', error);
        return null;
    }

}


export async function GetPossibleConfigurationAvailableForAccount(accountId: string, accountType: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetConfigurationAvailableForAccount");
        var params: ParamsApi = {
            query: {
                accountId: accountId,
                accountType: accountType
            }
        }
        const response = await restApiClient.fetch("GetPossibleConfigurationAvailableForAccount", params);
        return response!;

    } catch (error) {
        console.error('Error getting GetPossibleConfigurationAvailableForAccount data:', error);
        return null;
    }

}

export async function GetPaymentConfigurationAvailableForAccount(accountId: string, accountType: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetPaymentConfigurationAvailableForAccount");
        var params: ParamsApi = {
            query: {
                accountId: accountId,
                accountType: accountType
            }
        }
        const response = await restApiClient.fetch("GetPaymentConfigurationAvailableForAccount", params);
        return response!;

    } catch (error) {
        console.error('Error getting GetPaymentConfigurationAvailableForAccount data:', error);
        return null;
    }

}



export async function CreateCommissionConfiguration(userId: string, name: string, contractSelected: string): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: CreateCommissionConfiguration");

        const data = {
            userId: userId,
            name: name,
            contractSelected: contractSelected
        }
        var params: ParamsApi = {
            body: data
        }


        const response = await restApiClient.fetch("CreateCommissionConfiguration", params);
        return response!;

    } catch (error) {
        console.error('Error getting CreateCommisionConfiguration data:', error);
        return null;
    }

}

export async function DeleteCommissionConfiguration(id: string): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: DeleteCommissionConfiguration");

        var params: ParamsApi = {
            query: {
                id: id,
            }
        }


        const response = await restApiClient.fetch("DeleteCommissionConfiguration", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error getting DeleteCommissionConfiguration data:', error);
        return null;
    }

}


export async function CalculateAffectedAccounts(countries: Array<string>, accounts: Array<AccountValues>): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CalculateAffectedAccounts");


        const data = {
            countries: countries,
            accounts: accounts,
        }
        var params: ParamsApi = {
            body: data
        }
        const response = await restApiClient.fetch("CalculateAffectedAccounts", params);
        return response!;

    } catch (error) {
        console.error('Error getting CalculateAffectedAccounts data:', error);
        return null;
    }
}



export async function EditCommissionConfiguration(d: EditAccountAsignationData): Promise<ApiResponse | null> {

    try {

        console.warn("Calling to: EditCommissionConfiguration");

        const data = {
            id: d.id,
            name: d.name,
            selectedContract: d.contractSelected,
            selectedMarkets: d.marketsSelected,
            selectedAccounts: d.accountsSelected ?? null, // key: accountId, value: accountType
            applyFrom: d.applyFrom,
            ApplyTo: d.applyTo,
            Status: d.status
        }
        var params: ParamsApi = {
            body: data
        }

        const response = await restApiClient.fetch("EditCommissionConfiguration", params);
        return response!;

    } catch (error) {
        console.error('Error getting EditCommissionConfiguration data:', error);
        return null;
    }

}


export async function CheckConfigurationAccountConflict(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckConfigurationConflict");
        var params: ParamsApi = {
            query: {
                id: id
            }
        }
        const response = await restApiClient.fetch("CheckConfigurationAccountConflict", params);

        return response!;

    } catch (error) {
        console.error('Error getting CheckConfigurationAccountConflict data:', error);
        return null;
    }
}



export async function CheckConfigurationCountryConflict(id: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckConfigurationCountryConflict");
        var params: ParamsApi = {
            query: {
                id: id
            }
        }
        const response = await restApiClient.fetch("CheckConfigurationCountryConflict", params);

        return response!;

    } catch (error) {
        console.error('Error getting CheckConfigurationCountryConflict data:', error);
        return null;
    }
}



export async function GetConfigurationAccounts(countries: Array<string> | null, name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetConfigurationAccounts", countries);


        // Inicializa el objeto query vacío y agrégale las propiedades si no son nulas
        const query: { [key: string]: any } = {};
        if (countries) {
            query.countries = countries; // Agrega solo si no es null
        }
        if (name) {
            query.name = name; // Incluye el nombre si está definido
        }

        const params: ParamsApi = {
            query,
        };
        const response = await restApiClient.fetch("GetConfigurationAccounts", params);
        return response!;
    } catch (error) {
        console.error('Error getting GetConfigurationAccounts data:', error);
        return null;
    }
}










/////////////////////////////////////////////////////////////////////////
export async function DeletePaymentsConfiguration(id: string): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: DeletePaymentsConfiguration");

        var params: ParamsApi = {
            query: {
                id: id,
            }
        }


        const response = await restApiClient.fetch("DeletePaymentsConfiguration", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error getting DeletePaymentsConfiguration data:', error);
        return null;
    }

}





export async function EditPaymentMethodConfiguration(d: EditPaymentConfigurationData): Promise<ApiResponse | null> {

    try {

        console.warn("Calling to: EditPaymentMethodConfiguration");

        const data = {
            id: d.id,
            name: d.name,
            marketsSelected: d.marketsSelected,
            accountsSelected: d.accountsSelected,
            paymentsMethodSelected: d.paymentsMethodSelected,
            IsActive: d.isActive,
            isDefault: d.isDefault
        }
        var params: ParamsApi = {
            body: data
        }



        const response = await restApiClient.fetch("EditPaymentMethodConfiguration", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error getting EditPaymentMethodConfiguration data:', error);
        return null;
    }

}



export async function CreatePaymentMethodConfiguration(userId: string, name: string, isDefault: boolean): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: CreatePaymentMethodConfiguration");

        const data = {
            userId: userId,
            name: name,
            isDefault: isDefault
        }
        var params: ParamsApi = {
            body: data
        }



        const response = await restApiClient.fetch("CreatePaymentMethodConfiguration", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error getting CreateCommisionConfiguration data:', error);
        return null;
    }

}






export async function GetPaymentsMethodConfiguration(data: PaymentConfigurationsFilter): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetPaymentsMethodConfiguration");
        var params: ParamsApi = {
            query: {
                idPaymentMethod: data.paymentMethodId ?? "",
                name: data.name ?? "",
                page: data.page ?? 0,
                pageSize: data.pageSize ?? 10
            }
        }
        const response = await restApiClient.fetch("GetPaymentsMethodConfiguration", params);
        return response!;

    } catch (error) {
        console.error('Error getting GetPaymentsMethodConfiguration data:', error);
        return null;
    }
}



export async function GetPaymentsMethods(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetPaymentsMethods");

        var params: ParamsApi = {
            query: {
                app: "bo"
            }
        }

        const response = await restApiClient.fetch("GetPaymentsMethods", params);

        return response!;

    } catch (error) {
        console.error('Error getting GetPaymentsMethods data:', error);
        return null;
    }

}


export async function GetCountries(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetCountries");

        const response = await restApiClient.fetch("GetCountries", {});
        return response!;

    } catch (error) {
        console.error('Error getting GetCountries data:', error);
        return null;
    }

}

export async function GetCountriesWS(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetCountries");

        const response = await restApiClient.fetch("GetCountriesWS", {});
        return response!;

    } catch (error) {
        console.error('Error getting GetCountriesWS data:', error);
        return null;
    }

}

export async function GetAllContracts(): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetAllContracts");

        const response = await restApiClient.fetch("GetAllContracts", {});
        return response!;

    } catch (error) {
        console.error('Error getting GetAllContracts data:', error);
        return null;
    }

}





export async function CheckIsValidCommissionConfigurationName(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckIsValidCommissionConfigurationName");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckIsValidCommissionConfigurationName", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckIsValidCommissionConfigurationName data:', error);
        return null;
    }
}

export async function CheckIsValidPaymentConfigurationName(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckIsValidPaymentConfigurationName");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckIsValidPaymentConfigurationName", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckIsValidPaymentConfigurationName data:', error);
        return null;
    }
}




export async function ResendConfirmationEmail(userId: string): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: ResendConfirmationEmail");

        const data = {
            userId: userId,
        }
        var params: ParamsApi = {
            body: data
        }


        const response = await restApiClient.fetch("ResendConfirmationEmail", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error getting ResendConfirmationEmail data:', error);
        return null;
    }

}


export async function SaveAdditionalConfigurationRegisterForm(hasVerificationCode: boolean): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: SaveAdditionalConfigurationRegisterForm");
        const data = {
            hasVerificationCode: hasVerificationCode
        }
        var params: ParamsApi = {
            body: data
        }


        const response = await restApiClient.fetch("SaveAdditionalConfiguration", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error calling SaveAdditionalConfigurationRegisterForm :', error);
        return null;
    }

}


export async function getGeneralMappingConfig(): Promise<ApiResponse | null> {
    try {

        console.warn("Calling to: GetGeneralMappingConfig");

        const response = await restApiClient.fetch("GetGeneralMappingConfig", {}, REDIRECT_TO_ERROR_PAGE);

        return response!;

    } catch (error) {
        console.error('Error fetching mapping config:', error);
        return null;
    }
}


export async function SaveGeneralMappingConfig(directIntegrationChannelCode: string): Promise<ApiResponse | null> {

    try {
        console.warn("Calling to: SaveAdditionalConfigurationRegisterForm");
        const data = {
            directIntegrationChannelCode: directIntegrationChannelCode
        }
        var params: ParamsApi = {
            body: data
        }


        const response = await restApiClient.fetch("SaveGeneralMappingConfig", params);
        return response!;
        //  return null;

    } catch (error) {
        console.error('Error calling SaveGeneralMappingConfig :', error);
        return null;
    }

}

export async function cancelBookingRewards(bookingId: string): Promise<ApiResponse | null> {
    console.warn("Calling to: CancelBookingRewards", bookingId);
    try {
        const data = { bookingId: bookingId }
        var params: ParamsApi = {
            body: data
        }
        const response = await restApiClient.fetch("CancelBookingRewards", params, REDIRECT_TO_ERROR_PAGE);

        return response;

    } catch (error) {
        console.error('Error push notification data:', error);
        return null;
    }
}


export async function ImportBookingRewards(bookingData: ImportBookingRewardsData): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: importBookingRewards", bookingData);

        const response = await restApiClient.fetch("ImportBookingRewards", {
            body: bookingData
        });

        return response!;


    } catch (error) {
        console.error('Error ImportBookingRewards :', error);
        return null;
    }
}
export async function CompleteBookingPayment(data: CompleteBookingPaymentRequest): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CompleteBookingPayment", data);

        const response = await restApiClient.fetch("CompleteBookingPayment", {
            body: data
        });

        return response!;

    } catch (error) {
        console.error('Error CompleteBookingPayment :', error);
        return null;
    }
}




export async function CheckRoomPmsCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckRoomPmsCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckRoomPmsCode", params);
        return response!;
        //   return null;

    } catch (error) {
        console.error('Error getting CheckRoomPmsCode data:', error);
        return null;
    }
}

export async function CheckRegimenPmsCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckRegimenPmsCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckRegimenPmsCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckRegimenPmsCode data:', error);
        return null;
    }
}

export async function CheckServiceCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckServiceCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckServiceCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckServiceCode data:', error);
        return null;
    }
}

export async function CheckHotelPmsCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckHotelPmsCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckHotelPmsCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckHotelPmsCode data:', error);
        return null;
    }
}


export async function CheckRoomIntegrationCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckRoomIntegrationCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckRoomIntegrationCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckRoomIntegrationCode data:', error);
        return null;
    }
}

export async function CheckRegimenIntegrationCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckRegimenIntegrationCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckRegimenIntegrationCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckRegimenIntegrationCode data:', error);
        return null;
    }
}



export async function CheckHotelIntegrationCode(name: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: CheckHotelIntegrationCode");
        var params: ParamsApi = {
            query: {
                name: name
            }
        }
        const response = await restApiClient.fetch("CheckHotelIntegrationCode", params);
        return response!;

    } catch (error) {
        console.error('Error getting CheckHotelIntegrationCode data:', error);
        return null;
    }
}

export async function ForceRefreshCache(hotelCodes: string[], language: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: ForceRefreshCache");
        var params: ParamsApi = {
            body: {
                hotelCodes: hotelCodes,
                languageIsoCode: language
            }
        }
        const response = await restApiClient.fetch("ForceRefreshCache", params);
        return response!;

    } catch (error) {
        console.error('Error getting ForceRefreshCache data:', error);
        return null;
    }
}



export async function GetPCIProxyTransactionIdByAliasToken(alias: string, aliasCVV: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: GetPCIProxyTransactionIdByAliasToken");
        const data = {
            aliasCardId: alias,
            aliasCVV: aliasCVV
        }
        var params: ParamsApi = {
            body: data
        }
        const response = await restApiClient.fetch("GetPCIProxyTransactionIdByAliasToken", params);
        return response!;

    } catch (error) {
        console.error('Error post GetPCIProxyTransactionIdByAliasToken data:', error);
        return null;
    }
}

export async function getAllCountries(): Promise<ApiResponse | null> {
    console.warn("Calling to: GetCountries");
    try {
        const response = await restApiClient.fetch("GetCountries", {}, REDIRECT_TO_ERROR_PAGE);
        return response;
    } catch (error) {
        console.error('Error fetching countries:', error);
        return null;
    }
}




export async function getWSUsers(): Promise<ApiResponse | null> {
    console.warn("Calling to: GetWSUsers");
    try {
        const response = await restApiClient.fetch("GetWSUsers", {}, REDIRECT_TO_ERROR_PAGE);
        return response;
    } catch (error) {
        console.error('Error fetching WS users:', error);
        return null;
    }
}



export async function editWSUser(market : string ,username: string, password: string): Promise<ApiResponse | null> {
    console.warn("Calling to: editWSUser", { market, username, password });

    try {

          const data = {
            Username: username,
            Password: password,
            Market: market
        }
        
        const response = await restApiClient.fetch("EditWSUser", {
            body: data
        }, REDIRECT_TO_ERROR_PAGE);

        return response!;

    } catch (error) {
        console.error('Error editing WS user :', error);
        return null;
    }
}




export async function createWSUser(market : string ,username: string, password: string): Promise<ApiResponse | null> {
    console.warn("Calling to: createWSUser", { market, username, password });

    try {

          const data = {
            Username: username,
            Password: password,
            Market: market
        }
  
        const response = await restApiClient.fetch("CreateWSUser", {
            body: data
        }, REDIRECT_TO_ERROR_PAGE);

        return response!;

    } catch (error) {
        console.error('Error creating WS user :', error);
        return null;
    }
}





export async function deleteWSUser(market: string): Promise<ApiResponse | null> {
    try {
        console.warn("Calling to: deleteWSUser", { market });

        var params: ParamsApi = {
            query: {
                Market: market
            }
        }

        const response = await restApiClient.fetch("DeleteWSUser", params, REDIRECT_TO_ERROR_PAGE);
        return response!;

    } catch (error) {
        console.error('Error deleting WS user:', error);
        return null;
    }
}
